import { render, staticRenderFns } from "./Control_landing.vue?vue&type=template&id=0115e840&scoped=true&lang=pug&"
import script from "./Control_landing.vue?vue&type=script&lang=js&"
export * from "./Control_landing.vue?vue&type=script&lang=js&"
import style0 from "./Control_landing.vue?vue&type=style&index=0&id=0115e840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115e840",
  null
  
)

export default component.exports